import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import PageLoader from '../components/PageLoader';

// Login, register and password screens are standalone full-screen pages per the Figma
// (no site header or footer), so they get a bare layout instead of PublicLayout.
export default function AuthLayout() {
  return (
    <main>
      <Suspense fallback={<PageLoader />}>
        <Outlet />
      </Suspense>
    </main>
  );
}
